export default __webpack_public_path__ + "static/media/other-users-skills-mobile.355d7bbe.svg";